import { Component, Input, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { MediaService } from 'src/app/service/media/media.service';
import { DialogService } from 'src/app/service/dialog/dialog.service';

@Component({
  selector: 'app-attachments-card',
  templateUrl: './attachments-card.component.html',
  styleUrls: ['./attachments-card.component.scss'],
})
export class AttachmentsCardComponent implements OnInit {
  @ViewChild('imageModal') imageModal;
  @Input() allowChanges: boolean;
  @Input() action: any;
  @Input() label: string;
  @Input() attachmentType: string;
  @Input() parentId: string;
  @Input() parentType: string;
  @Input() key: string;
  @Input() attachments: Array<any> = [];
  @Input() source: string;
  @Output() uploadAction = new EventEmitter<any>();
  @Output() deleteAction = new EventEmitter<any>();

  imageUrl: string;
  dialogRecord: any = {};
  bodyStyles: any = {
    'min-height': '250px',
    display: 'flex',
    'flex-wrap': 'wrap',
    color: '#4f4f4f',
    'font-weight': 'bold',
  };

  get allowedImageTypes(): string {
    return ['image/*'].join(',');
  }

  get allowedDocumentType(): string {
    return ['.pdf', '.doc', '.PDF', '.docx', '.xlsx', '.xls', '.txt', '.csv'].join(',');
  }

  get allowedFileTypes() {
    return {
      image: this.allowedImageTypes,
      document: this.allowedDocumentType,
    };
  }

  get bodyStyle() {
    return {
      image: { ...this.bodyStyles, 'min-height': '250px' },
      document: { ...this.bodyStyles, 'align-content': 'flex-start' },
    };
  }

  constructor(
    private mediaService: MediaService,
    private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.initDialog();
  }

  initDialog() {
    this.dialogRecord.actionType = 'delete';
    this.dialogRecord.actionName = 'Delete';
    this.dialogRecord.name = 'document';
  }

  showImage(imageUrl: string): void {
    this.imageUrl = imageUrl;
    this.imageModal.nativeElement.click();
  }

  handleUpload(event: any) {
    if (!event?.target?.files) return

    const formData: FormData = new FormData();

    for (let i = 0; i < event.target.files.length; i++) {
      formData.append('files', event.target.files[i]);
    }

    formData.append('parentId', this.parentId);
    formData.append('parentType', this.parentType);
    formData.append('category', this.attachmentType);

    this.mediaService.create['models'](formData).subscribe(
      res => {
        const { data } = res;
        const { key } = this;
        this.uploadAction.emit({ data, key });
      },
      error => {
        console.error(error);
      },
    );
  }

  handleDelete(id: number) {
    this.dialogRecord.actionType = 'delete';
    this.dialogRecord.actionName = 'Delete';
    this.dialogRecord.name = this.attachmentType;
    this.dialogService.open(`delete-${this.attachmentType}`).then(res => {
      if (!res) {
        this.initDialog()
        return
      }

      this.mediaService.delete['models'](id).subscribe(
        () => {
          this.initDialog();
          this.deleteAction.emit({ id, key: this.key });
        },
        error => {
          console.error(error);
        },
      );
    });
  }
}
